<template>
  <g>
    <path fill="#8BC34A" :style="{fill : $attrs.fgColor}"
          d="M27.9,13.3C26.4,8.5,21.1,5,15,5C7.7,5,1.7,10,1.7,16.2c0,3.6,1.9,6.7,5,8.8L5,30l5.2-3.2
	c1.4,0.5,3.1,0.8,4.8,0.8c0.2,0,0.4,0,0.6,0c-0.3-1.1-0.6-2.2-0.6-3.3c0-6,5.6-10.8,12.5-10.8C27.6,13.3,27.9,13.3,27.9,13.3z
	 M20,10.8c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7S19.1,10.8,20,10.8z M10,14.2c-0.9,0-1.7-0.8-1.7-1.7
	s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7S10.9,14.2,10,14.2z"/>
    <path fill="#CFD8DC" :style="{fill : $attrs.fgColor}"
          d="M38.3,24.2c0-5.1-4.8-9.2-10.8-9.2s-10.8,4.1-10.8,9.2c0,5.1,4.8,9.2,10.8,9.2c1.5,0,2.9-0.2,4.2-0.7l4.2,2.3
	l-1.2-4C36.9,29.3,38.3,26.9,38.3,24.2z M23.8,23.3c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2
	C25,22.8,24.4,23.3,23.8,23.3z M31.2,23.3c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2
	C32.5,22.8,31.9,23.3,31.2,23.3z"/>
  </g>
</template>

<script>
export default {
  name: "svgWechat"
}
</script>

<style scoped>

</style>